/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useEffect } from "react";
import { FaEye } from "react-icons/fa";
import { BiTrash } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import AppButton from "../../common/AppButton";
import Table from "../../common/Table";
import Body from "../../components/Body";
import api from "../../config/api";
import useHeader from "../../hooks/useHeader";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOrganizations } from "../../stores/OrganizationStore";
import { getContracts } from "../../stores/ContractStore";
import { useLocation } from "react-router-dom";
const header = [
  { name: "contractId", title: "Contract ID", filter: "Search" },
  { name: "client", title: "Client", filter: "Search" },
  // { name: "location", title: "Location", filter: "Search" },
  { name: "startDate", title: "Start", filter: "DatePicker" },
  { name: "endDate", title: "End", filter: "DatePicker" },
  // { name: "status", title: "Status", style: { textAlign: "left" } },
];

function Contracts() {
  const navigate = useNavigate();
  const { setHeader } = useHeader();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();

  const { data: organizations } = useQuery({
    queryFn: () => getOrganizations(),
    queryKey: ["organizations"],
  });

  const { data: contracts } = useQuery({
    queryFn: () => getContracts(),
    queryKey: ["contracts"],
  });

  const data = contracts?.map((i) => {
    return {
      ...i,
      organization: organizations?.find((item) => item._id === i.organization),
      location: i.location,
      client: organizations?.find((item) => item._id === i.organization)?.name,
      startDate: moment(i.contractStartDate).format("DD/MM/YYYY"),
      endDate: moment(i.contractEndDate).format("DD/MM/YYYY"),
    };
  });

  useEffect(() => {
    setHeader("Contracts");
  }, []);

  const handleView = (data) => {
    navigate(`/contracts/view/${data.organization._id}/contract/${data._id}`, {
      state: { data: cloneDeep(data) },
    });
  };
  const handleDelete = async (inv) => {
    if (confirm("Are you sure want to delete the contract ?") === false)
      return false;
    const res = await api.put("contracts", { _id: inv._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["contracts"]);

    toast.success("Task has been succesfully deleted.");
  };

  return (
    <Body noPadding>
      <Table
        header={header}
        data={data}
        SideButtons={({ inv }) => {
          return (
            <div className="side-button">
              <AppButton
                onClick={() => handleView(inv)}
                tooltip="More Details"
                className="text-primary"
                leftIcon={<FaEye />}
              />

              <AppButton
                onClick={() => handleDelete(inv)}
                tooltip="Delete Job"
                className="text-primary"
                leftIcon={<BiTrash />}
              />
            </div>
          );
        }}
      />
    </Body>
  );
}
export default observer(Contracts);
